<template>
  <tr>
    <td>{{user.Profile.Name}}</td>
    <!-- 以下手機版不顯示 -->
    <td v-show="!isMobile">{{ department.Name }}</td>
    <td v-show="!isMobile">{{ userPosition }}</td>
    <td v-show="!isMobile">{{ loan | amountFormat }}</td>
    <td v-show="!isMobile">{{ ((item.LoanRecord && item.LoanRecord.Sum) ?'預支'+item.LoanRecord.Sum: '') | amountFormat}}</td>
    <!-- 以上手機版不顯示 -->
    <td>{{ (item.TotalTaskWorkingItemBonus + item.TotalWorkOrderBonus) | amountFormat }}</td>
    <td>{{ item.Amount | amountFormat }}</td>
    <td>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>
      <v-chip
        v-if="isSignEnabled"
        color="red"
        small
      >待審核</v-chip>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    userPosition() {
      let level = AppDataSetting.findUserLevel(this, this.user);

      if (level === 1) return "員工";
      if (level === 10) return "主管";
      if (level === 100) return "會計";
      if (level === 1000) return "總經理";
      if (level === 10000) return "蝦董";
      if (level === 100000) return "工程師";
      return level;
    },
    department() {
      const findUserDepartment = user => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };
      return findUserDepartment(this.user);
    },
    user() {
      return this.users.find(o => o.ID == this.item.UserID);
    },
    isSignEnabled() {
      let now = new Date()
      if (now.getFullYear() == this.item.Year && now.getMonth()+1 == this.item.Month) return false
      return this.item.Status == "確認中" && this.myLevel == 100;
    },
    loan() {
      if (!this.item.LoanRecord) return "";
      if (this.item.LoanRecord.Offset > 0)
        return `多欠${this.item.LoanRecord.Offset}`;
      if (this.item.LoanRecord.Offset < 0)
        return `還${this.item.LoanRecord.Offset}`;
      return "";
    },
    ...mapGetters([
      "myLevel",
      "users",
      "departments",
      "userDepartments",
      "userPositions"
    ])
  },
  methods: {
    view() {
      let id = this.item.ID;
      this.$store.state.UI.dialog.salaryDetail.id = id;
      this.$store.state.UI.dialog.salaryDetail.isShow = true;
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Name || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  }
};
</script>